
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isArray, isObject } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {CircularProgress} from "@material-ui/core";
import styled from "styled-components";
import {grey} from "@material-ui/core/colors";

const StyledLoadingSelect = styled.div`
  position: relative;
  
  .MuiInputBase-root {
    width: 100%;
  }
  
  .MuiCircularProgress-root {
    color: ${grey[500]};
    position: absolute;
    top: 50%;
    right: 40px;
    margin-top: -12px;
    margin-left: -12px;
  }
`;


export class SelectWidget extends Component {

  static propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    large: PropTypes.bool,
    emptyValue: PropTypes.any,
  };

  static defaultProps = {
    optionLabel: 'label',
    optionValue: 'value'
  };

  getOptionLabel = (option) => {
    return option[this.props.optionLabel];
  };

  getOptionValue = (option) => {
    return option[this.props.optionValue];
  };

  handleChange = (e) => {
    const { onChange, options } = this.props;
    const value = e.target.value;
    if (value) {
      onChange(value, options.find(o => this.getOptionValue(o) === value));
    }
    else {
      onChange(null, null);
    }
  };

  isValueSelected = (checkedValue) => {
    const { value } = this.props;
    return value.indexOf(checkedValue) > 0;
  };

  render() {
    const { value, options, onChange, large, optionLabel, optionValue, helperText, loading, ...otherProps } = this.props;

    if (loading) {
      return (
        <StyledLoadingSelect>
          <Select disabled={true} value={''} />
          <CircularProgress size={24} />
        </StyledLoadingSelect>
      )
    }

    let selectValue = null;
    if (value !== null && value !== undefined && !isArray(value)) {
      if (isObject(value)) {
        selectValue = this.getOptionValue(value);
      }
      else {
        selectValue = value;
      }
    }

    if (options.length === 0) {
      return (
        <Select value={''} disabled={true}>
          <MenuItem value="">
            <em>Без значения</em>
          </MenuItem>
        </Select>
      )
    }

    return (
      <Select
        value={selectValue || ''}
        onChange={(e) => this.handleChange(e)}
        {...otherProps}
      >
        {value && (
          <MenuItem value="">
            <em>Без значения</em>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={this.getOptionValue(option)} value={this.getOptionValue(option)}>
            {this.getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    );
  }
}
